import { css } from "@emotion/react"
import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"

export function DemoInlineSection({ title }: { title: string }) {
  const [sended, setSended] = useState(false)

  return (
    <section className="consultation text-white">
      <Container>
        <Row>
          <Col>
            <div css={all}>
              <Row className="px-4 px-md-5 px-lg-4 align-items-center align-items-lg-stretch">
                <Col lg={7} className="pt-5 p-lg-5">
                  {((!sended || !isWeekend) && <div dangerouslySetInnerHTML={{ __html: title }} />) || (
                    <>
                      <p>Мы получили заявку! Наши менеджеры перезвонят вам в понедельник с 10:00 до 12:00</p>
                      <div className="h3 mb-4">
                        Чтобы вы не грустили в ожидании звонка, мы дарим вам готовые сценарии использования поп‑апов и чат-бота, которые помогут вашему бизнесу
                        зарабатывать больше
                      </div>
                    </>
                  )}
                </Col>
                <Col lg={5} css={rightCol} className="pb-5 py-md-5 p-xl-5">
                  <a href="#open-demo-pop-up" className="btn btn-primary btn-demo">
                    Заказать демо
                  </a>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

// Проверяем день недели и определяем выходные
const yourDateObject = new Date()
const day = yourDateObject.getDay()
const isWeekend = day === 6 || day === 0 // 6 = Saturday, 0 = Sunday

const all = css`
  background-color: #5c5cd6;
  border-radius: 1.25rem;
`

const rightCol = css`
  .afterSendWeekend p {
    display: none;
  }
  .btn {
    margin-top: 0 !important;
    height: auto !important;
    @media (min-width: 1400px) {
      padding: 1rem 2rem;
    }
  }
`
